import React, { useState, useEffect } from 'react';
import "./product.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import barrier from "../../../Assets/sound-barrier-india.webp";
import { Link } from 'react-router';
import screen from "../../../Assets/screening.jpeg";
import { BsSoundwave } from "react-icons/bs";
import bigpanel from "../../../Assets/sound-barrier-manufacturer.webp";
import MFooter from '../../../Components/Main-Footer/MFooter';
import HNavbar from '../../../Components/Navbar/HNavbar';

function Product() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const animatedElements = document.querySelectorAll('.header,.header1,.header-2,.header-3,.header-4, .header-5');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);


    return (
        <>
            <HNavbar />
            <section id='product' className='product-home'>
                <div className='container p-0'>
                    <Sidebar />
                    <div className="hero-section">
                        <div className='row justify-content-center'>
                            <div className='col-sm-12 col-md-8 mt-5 justify-content-start d-flex align-items-center'>
                                <div className="text-start hero-content">
                                    <h1 className="header">Premium Acoustic Panels</h1>
                                    <h1 className="header1">for Superior Sound Control</h1>

                                    <p className="content">
                                        High-performance acoustic panels designed to improve<br />
                                        sound clarity, reduce echo, and enhance interior acoustics<br />
                                        for commercial and residential spaces. Our panels are<br />
                                        engineered for durability, aesthetic appeal, and maximum<br />
                                        noise absorption
                                    </p>

                                    <Link to="/contact">
                                        <button className="btn">Contact us</button>
                                    </Link>
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-4'>
                                <img src={barrier} alt="panel" className='img-fluid' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className='container p-3 mt-2'>
                <h1 className='header-2'>What Are Acoustic Panels?</h1>
                <p style={{ textAlign: "justify" }}>Acoustic panels are specialized sound-absorbing materials used to control noise levels, reduce reverberation, and improve speech clarity inside a room. They are ideal for offices, auditoriums, studios, cinemas, conference rooms, and home theatres.</p>
                <p style={{ textAlign: "justify" }}>Our premium acoustic panels are made using advanced sound-absorbing cores with high NRC ratings to ensure effective performance.</p>

                <h4>Key Features of Our Sound Barrier</h4>
                <div className='row'>
                    <div className='col-sm-12 col-md-6 justify-content-center d-flex align-items-center'>
                        <ul className='list'>
                            <li>High NRC (Noise Reduction Coefficient) rating</li>
                            <li>Excellent echo and reverberation control</li>
                            <li>Fire-retardant material options available</li>
                            <li>Eco-friendly and non-toxic composition</li>
                            <li>Available in multiple colors and fabric finishes</li>
                            <li>Easy wall and ceiling installation</li>
                            <li>Long-lasting durability</li>
                        </ul>
                    </div>
                    <div className='col-sm-12 col-md-6 align-items-start justify-content-center d-flex'>
                        <img className='img-fluid' src={screen} alt="graph" />
                    </div>
                </div>
                <div className='col-sm-12 diamend'>
                    <h4>Benefits of Installing Acoustic Panels</h4>

                    <div className='benefit-item'>
                        <span className='icon'><BsSoundwave /></span>
                        <div>
                            <h6>Improved Sound Quality</h6>
                            <p>Enhances speech clarity and reduces background noise for better communication</p>
                        </div>
                    </div>

                    <div className='benefit-item'>
                        <span className='icon'><BsSoundwave /></span>
                        <div>
                            <h6>Professional Interior Appearance</h6>
                            <p>Available in customizable colors and textures to match modern interior designs</p>
                        </div>
                    </div>

                    <div className='benefit-item'>
                        <span className='icon'><BsSoundwave /></span>
                        <div>
                            <h6>Increased Productivity</h6>
                            <p>Reduced noise levels help improve focus and efficiency in work environments</p>
                        </div>
                    </div>

                    <div className='benefit-item'>
                        <span className='icon'><BsSoundwave /></span>
                        <div>
                            <h6>Cost-Effective Soundproofing Solution</h6>
                            <p>Affordable and long-lasting acoustic treatment solution</p>
                        </div>
                    </div>
                </div>
                <div className='col-sm-12'>
                    <h1 className='header-3'>Technical Specifications</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 align-items-center justify-content-center d-flex'>
                            <img className='img-fluid' src={bigpanel} alt="panel" />
                        </div>
                        <div className='col-sm-12 col-md-6 align-items-center justify-content-center d-flex'>
                            <ul className='list'>
                                <li>Thickness: 25mm / 50mm</li>
                                <li>Density: High-density acoustic core</li>
                                <li>Surface Finish: Fabric / Polyester</li>
                                <li>Installation: Adhesive / Mechanical fixing</li>
                                <li>Fire Rating: Available upon request</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <section id='product' className='product-contact'>
                <div className='container p-0'>
                    <div className='col-sm-12 whochoose p-4'>
                        <h1 className='header-4'>Why Choose Us for Acoustic Solutions?</h1>
                        <ul className='list white-para'>
                            <li>Industry-leading acoustic technology</li>
                            <li>Custom design and sizing options</li>
                            <li>Expert installation support</li>
                            <li>Proven performance in multiple projects</li>
                            <li>Competitive pricing</li>
                        </ul>

                        <h1 className='header-5' style={{ marginTop: "3%" }}>Get a Free Acoustic Consultation</h1>
                        <div className='row p-2 mt-3'>
                            <div className='col-sm-12 col-md-6'>
                                <p className='white-para'>Looking for professional acoustic

                                    treatment solutions?

                                    Contact us today for expert

                                    guidance and customized recommendations

                                    for your space.
                                </p>
                            </div>
                            <div className="col-12 col-md-6 mt-3">
                                <div className="row">
                                    <div className="col-sm-12 col-md-4 mb-3">
                                        <input
                                            type="text"
                                            name="name"
                                            id="name"
                                            className="form-control"
                                            placeholder="Name *"
                                        />
                                    </div>
                                    <div className="col-sm-12 col-md-4 mb-3">
                                        <input
                                            type="email"
                                            name="mail"
                                            id="mail"
                                            className="form-control"
                                            placeholder="Email *"
                                        />
                                    </div>
                                    <div className="col-sm-12 col-md-4 mb-3">
                                        <input
                                            type="text"
                                            name="phone"
                                            id="phone"
                                            className="form-control"
                                            placeholder="Phone *"
                                        />
                                    </div>
                                    <div className="col-12 mb-3">
                                        <textarea
                                            rows={4}
                                            id="message"
                                            className="form-control"
                                            placeholder="Message *"
                                        ></textarea>
                                    </div>
                                    <div className="col-12">
                                        <button
                                            className="btn"
                                            type="button"
                                            onClick={handleClick}
                                        >
                                            SEND
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )}
            <MFooter />
        </>
    )
}

export default Product